import request from '@/services/request';

import {
  GetPartnersBankDetailsBase,
  PostPartnersBankDetailsBase,
  PostPartnersBankDetailsResponseBase,
} from './types';

export type { GetPartnersBankDetailsBase, PostPartnersBankDetailsResponseBase };

type GetParams = {
  id?: number;
  user_id?: number;
};
type GetPartnersBankDetails = (params?: GetParams) => Promise<GetPartnersBankDetailsBase[]>;

export const getPartnersBankDetails: GetPartnersBankDetails = async (params) => {
  const id = params?.id;
  const user_id = params?.user_id;

  if (id) {
    const { data } = await request.get(`/financial/partner/bank_details/${id}`);
    return data;
  }

  const { data } = await request.get(`/financial/partner/bank_details/`, {
    params: { user_id },
  });
  return data;
};

type OptionalPostPartnersBankDetails = Partial<PostPartnersBankDetailsBase>;
type PostPartnersBankDetails = (
  data: OptionalPostPartnersBankDetails,
) => Promise<PostPartnersBankDetailsResponseBase>;
export const postPartnersBankDetails: PostPartnersBankDetails = async (data) => {
  const response = await request.post('/financial/partner/bank_details/', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

type PathPartnersBankDetails = (id: number) => Promise<PostPartnersBankDetailsBase>;
export const pathPartnersBankDetails: PathPartnersBankDetails = async (id) => {
  const { data } = await request.patch(`/financial/partner/bank_details/${id}`);
  return data;
};
